module.exports = __webpack_public_path__ + "img/icon-white-list.8f4776b7.svg";